/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Open_PrepInputs */



/**
* | output |
* | --- |
* | "Open preparation" |
*
* @param {Chat_Activity_Open_PrepInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_open_prep = /** @type {((inputs?: Chat_Activity_Open_PrepInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Open_PrepInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Open voorbereiding")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir la préparation")
	return /** @type {LocalizedString} */ ("Open preparation")
});